import type { SVGProps } from "react";
const SvgAirplane02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 9.5 5.275 4.476c-.418-.452-.351-.781.142-1.066.928-.537 1.65-.551 2.627-.015l4.905 2.692c.35.191.692.386 1.051.492M12.5 13.663l2.11 6.807c.173.556.476.656.946.387.884-.507 1.24-1.092 1.264-2.146l.12-5.291c.015-.707.013-1.399.56-1.92"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.328 10.984 1.887-1.378 4.429-3.229s1.635-1.201 2.548-1.601c1.084-.475 2.095-.254 3.182.05.562.156.843.235 1.046.381.322.233.531.59.574.981.027.247-.044.527-.187 1.086h0c-.278 1.08-.589 2.054-1.548 2.744-.808.58-2.68 1.377-2.68 1.377l-5.047 2.17-2.154.923h0c-.78.334-1.171.502-1.437.812-.622.727-.71 2.044-.942 2.95-.128.5-.832 1.367-1.458 1.237-.387-.08-.395-.565-.443-.874l-.464-2.974c-.11-.711-.12-.726-.688-1.176l-2.378-1.884c-.247-.195-.669-.444-.546-.815.2-.6 1.312-.768 1.815-.628.911.255 2.11.838 3.06.67.405-.072.747-.322 1.431-.822"
    />
  </svg>
);
export default SvgAirplane02;
